<template>
  <span
    ref="badge"
    class="inline-flex h-9 cursor-default items-center gap-2 rounded-md px-2.5 text-sm font-medium shadow-xs select-none"
    :class="[`bg-theme-${color}`, isLight ? 'text-gray-900' : 'text-white']"
    :title="tooltip"
  >
    <FontAwesomeIcon :icon="['fal', iconName]" />
    <span class="hidden capitalize-first 2xl:inline">{{ tooltip }}</span>
    <span
      v-if="count"
      class="rounded-full px-1.5 text-xs leading-5 font-bold"
      :class="isLight ? 'bg-black/10' : 'bg-white/25'"
    >
      {{ count }}
    </span>
  </span>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * A counter of the top bar (works per status, urns): not a link, its label
 * shows once the screen is wide enough, the tooltip otherwise.
 */
export default {
  name: 'NotificationIconComponent',
  components: { FontAwesomeIcon },
  props: {
    count: { type: [Number, String], default: 0 },
    color: { type: String, default: 'danger' },
    tooltip: { type: String, default: '' },
    icon: { type: String, required: true }
  },
  data() {
    return { isLight: false }
  },
  computed: {
    // The API sends Font Awesome class names (fa-database).
    iconName() {
      return this.icon.replace(/^fa-/, '')
    }
  },
  watch: {
    color() {
      this.$nextTick(this.readBackground)
    }
  },
  mounted() {
    this.readBackground()
  },
  methods: {
    // The colour comes from the API: pick dark text on a light background.
    readBackground() {
      const rgb = getComputedStyle(this.$refs.badge)
        .backgroundColor.match(/\d+(\.\d+)?/g)
        ?.map(Number)
      if (!rgb) return
      const [r, g, b] = rgb
      this.isLight = (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6
    }
  }
}
</script>
